import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CupomDesconto {
  id: number;
  codigo: string;
  descricao: string | null;

  quartos: {
    id: number;
    nome: string;
  }[];

  tipoDesconto: 'PERCENTUAL' | 'VALOR_FIXO';
  valorDesconto: number;

  dataInicio: string;
  dataFim: string;

  limiteUtilizacoes: number | null;
  quantidadeUtilizacoes: number;

  ativo: boolean;

  criadoEm: string;
  atualizadoEm: string;
}

export interface CupomDescontoRequest {
  codigo: string;
  descricao?: string;
  quartosIds: number[];
  tipoDesconto: 'PERCENTUAL' | 'VALOR_FIXO';
  valorDesconto: number;
  dataInicio: string;
  dataFim: string;
  limiteUtilizacoes?: number | null;
  ativo?: boolean;
}

export interface AplicarCupomRequest {
  codigo: string;
  quartoId: number;
  valorReserva: number;
}

export interface AplicarCupomResponse {
  valido: boolean;
  codigo: string;
  tipoDesconto: 'PERCENTUAL' | 'VALOR_FIXO';
  valorDesconto: number;
  valorDescontoCalculado: number;
  valorOriginal: number;
  valorFinal: number;
  mensagem: string;
}

@Injectable({
  providedIn: 'root'
})
export class CupomDescontoService {

  private readonly http = inject(HttpClient);

  private readonly apiUrl =
    `${environment.apiUrl}/admin/cupons`;

  listar(): Observable<CupomDesconto[]> {
    return this.http.get<CupomDesconto[]>(
      this.apiUrl
    );
  }

  buscar(id: number): Observable<CupomDesconto> {
    return this.http.get<CupomDesconto>(
      `${this.apiUrl}/${id}`
    );
  }

  criar(
    dto: CupomDescontoRequest
  ): Observable<CupomDesconto> {

    return this.http.post<CupomDesconto>(
      this.apiUrl,
      dto
    );
  }

  atualizar(
    id: number,
    dto: CupomDescontoRequest
  ): Observable<CupomDesconto> {

    return this.http.put<CupomDesconto>(
      `${this.apiUrl}/${id}`,
      dto
    );
  }

  alterarStatus(
    id: number,
    ativo: boolean
  ): Observable<CupomDesconto> {

    return this.http.patch<CupomDesconto>(
      `${this.apiUrl}/${id}/status`,
      null,
      {
        params: {
          ativo
        }
      }
    );
  }

  excluir(id: number): Observable<void> {

    return this.http.delete<void>(
      `${this.apiUrl}/${id}`
    );
  }

  aplicar( dto: AplicarCupomRequest ): Observable<AplicarCupomResponse> {
    return this.http.post<AplicarCupomResponse>(
      `${environment.apiUrl}/cupons/aplicar`, dto
    );
  }
}
